import { useCurrentStateAndParams } from "@uirouter/react";
import IncomingTrafficSingle from "app/pages/website-analysis/incoming-traffic/single/IncomingTrafficSingle";
import IncomingTrafficCompare from "app/pages/website-analysis/incoming-traffic/compare/IncomingTrafficCompare";

export const IncomingTrafficContainer = () => {
    const { params } = useCurrentStateAndParams();
    const isCompare = params.key.split(",").length > 1;

    return isCompare ? (
        <IncomingTrafficCompare params={params} />
    ) : (
        <IncomingTrafficSingle params={params} />
    );
};
